module.exports = __webpack_public_path__ + "0b6bd4cab1216553ad1d56c756b0959e.png";